<template>
  <Modal v-model="show" title="微信扫码打开小程序上传" width="600" :closable="false" :mask-closable="false">
    <template #header>
      <p>
        <img src="../../assets/images/weixin.png" class="QRtitle">
        <span>微信扫码上传文件</span>
      </p>
    </template>
    <div style="position: relative;">
    
      <div class="QRcode">
        <img :src="'data:image/png;base64,'+qrcode" width="190" alt="">
      </div>
      <div style="margin-top:20px;">
       <Alert type="warning" show-icon>手机操作时请勿关闭该二维码，文件上传成功后自动显示。</Alert>
      </div>
      <Spin size="large" fix v-if="loading"></Spin>
    </div>
    <template #footer>
      <Button @click="colse()" style="margin-right: 5px">关闭</Button>
    </template>
  </Modal>
</template>
<script>
export default {
  props: {
    qrcode: { type: String },
    loading: { type: Boolean },
    show: { type: Boolean },
  },
  data() {
    return {}
  },
  methods: {
    colse() {
      this.$emit('colse')
    },
  },
}
</script>
